import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminAccessGuardProps {
  children: React.ReactNode;
}

/**
 * AdminAccessGuard - Higher-order component to protect admin routes
 * 
 * This component ensures that:
 * 1. Only admins can access admin routes
 * 2. Non-admin users are redirected to home page
 */
const AdminAccessGuard: React.FC<AdminAccessGuardProps> = ({ children }) => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is not authenticated or not an admin, redirect to home
    if (!user || !isAdmin()) {
      navigate('/', { replace: true });
      return;
    }
  }, [user, isAdmin, navigate]);

  // Don't render children if access should be blocked
  if (!user || !isAdmin()) {
    return null;
  }

  return <>{children}</>;
};

export default AdminAccessGuard;